var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExumNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#D5C0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 14.8497V26.7397C32 27.7097 31.21 28.5997 30.24 28.7197L29.93 28.7597C28.29 28.9797 25.98 29.6597 24.12 30.4397C23.47 30.7097 22.75 30.2197 22.75 29.5097V15.5997C22.75 15.2297 22.96 14.8897 23.29 14.7097C25.12 13.7197 27.89 12.8397 29.77 12.6797H29.83C31.03 12.6797 32 13.6497 32 14.8497Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7083 14.7097C18.8783 13.7197 16.1083 12.8397 14.2283 12.6797H14.1583C12.9583 12.6797 11.9883 13.6497 11.9883 14.8497V26.7397C11.9883 27.7097 12.7783 28.5997 13.7483 28.7197L14.0583 28.7597C15.6983 28.9797 18.0083 29.6597 19.8683 30.4397C20.5183 30.7097 21.2383 30.2197 21.2383 29.5097V15.5997C21.2383 15.2197 21.0383 14.8897 20.7083 14.7097ZM14.9983 17.7397H17.2483C17.6583 17.7397 17.9983 18.0797 17.9983 18.4897C17.9983 18.9097 17.6583 19.2397 17.2483 19.2397H14.9983C14.5883 19.2397 14.2483 18.9097 14.2483 18.4897C14.2483 18.0797 14.5883 17.7397 14.9983 17.7397ZM17.9983 22.2397H14.9983C14.5883 22.2397 14.2483 21.9097 14.2483 21.4897C14.2483 21.0797 14.5883 20.7397 14.9983 20.7397H17.9983C18.4083 20.7397 18.7483 21.0797 18.7483 21.4897C18.7483 21.9097 18.4083 22.2397 17.9983 22.2397Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExumNotificationIcon);
export default __webpack_public_path__ + "static/media/exum-notification-icon.6cd5536ffd18392938bd02138ed267cf.svg";
export { ForwardRef as ReactComponent };